import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        {/* 메인 스피너 */}
        <div className="relative mb-6">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent mx-auto"></div>
          <div className="absolute inset-0 rounded-full h-16 w-16 border-4 border-blue-200 mx-auto"></div>
        </div>
        
        {/* 메인 메시지 */}
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          データを読み込み中...
        </h2>
        
        <p className="text-gray-600 mb-6 max-w-sm mx-auto">
          SaaSコストデータを読み込んでいます。<br />
          少々お待ちください。
        </p>
        
        {/* 단계 표시 */}
        <div className="flex items-center justify-center space-x-2 mb-6">
          <div className="flex space-x-1">
            <div className="h-2 w-2 bg-blue-600 rounded-full animate-bounce"></div>
            <div className="h-2 w-2 bg-blue-600 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="h-2 w-2 bg-blue-600 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
        </div>
        
        {/* 진행 단계 */}
        <div className="text-sm text-gray-500 space-y-2">
          <div className="flex items-center justify-center space-x-2">
            <div className="animate-spin rounded-full h-3 w-3 border-2 border-green-500 border-t-transparent"></div>
            <span>API接続中...</span>
          </div>
          <div className="text-xs text-gray-400">
            ネットワークの状態によって時間がかかることがあります。
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 